// Default
export const APP = 'DEVICE_OVERVIEW';

// HTML IDs
export const BELT_CONTAINER_CONTAINER_ID = 'hardware-overview__belt-container';
export const ERROR_NOTIFICATION_CONTAINER_ID = 'hardware-overview__error-notification';
export const FILTER_PILL_CONTAINER_ID = 'filter-pill';
export const CHUNKING_BUTTON_CONTAINER_ID = 'hardware-overview__more-items';
export const TOTAL_DEVICES_CONTAINER_ID = 'hardware-overview__total-devices';
export const PRODUCT_CARD_CONTAINER_ID = 'hardware-overview__product-card';
export const ACCORDION_CONTAINER_ID = 'accordion-container';
export const TEXT_HEADER_CONTAINER_ID = 'hardware-overview__headline';

// Chunking
export const CHUNK_INIT = 1;
export const CHUNK_SIZE = 12;

// URL Params
export const CATEGORY_QUERYPARAM = 'filters';
export const CHUNK_QUERYPARAM = 'page';

// Tracking
export const TRACKING_PAGENAME = 'handys';
